
export interface INavigationItem {
    name: string;
    route: string;
    subItems?: INavigationItem[];
}

const NavigationItems: INavigationItem[] = [
    {
        name: "Home",
        route: "/"
    },
    {
        name: "Explore",
        route: "/explore"
    },
    {
        name: "Profile",
        route: "/profile/wallet"
    },
    {
        name: "NFT Sales",
        route: "/",
        subItems: [
            {
                name: "YetiSwap Summer NFT Collection",
                route: "/yts-summer-collection"
            },
            {
                name: "Heart Beats NFT Collection",
                route: "/sales/heartBeats"
            }
        ]
    },
    {
        name: "Activities",
        route: "/activities"
    },
    {
        name: "NFT Stake",
        route: "/nft-stake"
    },
    {
        name: "Create NFT",
        route: "/nft-create"
    }
]
export default NavigationItems;